import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";
import { UPDATE_ORGANIZATION_INFO } from "../types";
import {
  updateOrganizationInfoPending,
  updateOrganizationInfoFulfilled,
  updateOrganizationInfoRejected,
} from "../actions";
import {
  sendApiRequest,
  notifyError,
  notifySuccess,
} from "../../../actions";
import { ORGANIZATION_MESSAGES } from "../constants/organizationMessages";
import generateError from "../../../utilities/generateError";
const createPayload = (payload) => ({
  method: "post",
  url: "organization/update",
  onSuccess: [
    updateOrganizationInfoFulfilled,
    (response) => notifySuccess(ORGANIZATION_MESSAGES.SUCCESS),
  ],
  onError: [
    updateOrganizationInfoRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});
const meta = {
  api: "ajaxApi",
};
const updateOrganizationInfoEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(UPDATE_ORGANIZATION_INFO.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      return merge(
        of(updateOrganizationInfoPending()),
        of(sendApiRequest(createPayload({ ...payload }), meta))
      );
    })
  );
export default updateOrganizationInfoEpic$;



// WEBPACK FOOTER //
// ./src/features/organization/epics/updateOrganizationLoginEpic.js